import React from 'react'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import Routes from '~/routes'
import { store, persistor, history } from '~/store'
import { hot } from 'react-hot-loader/root'

function App() {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ConnectedRouter history={history}>
          <Routes />
        </ConnectedRouter>
      </PersistGate>
    </Provider>
  )
}

export default process.env.NODE_ENV !== 'production' ? hot(App) : App
